<template>
  <div>
    <b-modal v-model="agreementModal" size="lg" hide-footer title="Subscription Terms">
      <div v-html="agreement" class="pb-3"></div>
    </b-modal>
    <div class="tw-flex tw-gap-2 tw-items-start">
      <input type="checkbox" required class="tw-mt-1" name="agreement" :id="subscriptionAgreementId">

      <label :for="subscriptionAgreementId" class="tw-font-medium tw-text-md m-0">
        By purchasing a subscription, you agree to POCSTOCK's
        <a class="btn-link tw-font-medium cursor-pointer" @click="agreementModal = true">Subscription Terms</a>,
        <a href="/terms" target="_blank">Terms of Service</a>
        and
        <a href="/legal/privacy" target="_blank">Privacy Policy</a>
      </label>
    </div>

  </div>
</template>
<script>
export default {
  props: {
    agreement: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      agreementModal: false,
      randomId: Math.random().toString(36).substring(7)
    }
  },

  computed: {
    subscriptionAgreementId() {
      return `subscription_agreement_${this.randomId}`
    }
  }
}
</script>
